import React from 'react';
import { connect } from 'react-redux';
import { DBTextAreaObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class ObservationGaitGaitCycle extends React.Component {

    render() {
        return (
            <div>
                <div className={styles.row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='Gait Cycle' />
                    <label className={styles.label}>Gait Cycle</label>
                </div>
                <div className={styles.textarea_row}>
                    <span className={styles.flag} />
                    <label className={styles.textarea_sublabel_indent}>Initial Contact</label>
                    <DBTextAreaObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOGAICYCLEINITIAL'
                        className={styles.textarea}
                    />
                </div>
                <div className={styles.textarea_row}>
                    <span className={styles.flag} />
                    <label className={styles.textarea_sublabel_indent}>Stance Phase</label>
                    <DBTextAreaObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOGAICYCLESTANCE'
                        className={styles.textarea}
                    />
                </div>
                <div className={styles.textarea_row}>
                    <span className={styles.flag} />
                    <label className={styles.textarea_sublabel_indent}>Swing Phase</label>
                    <DBTextAreaObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOGAICYCLESWING'
                        className={styles.textarea}
                    />
                </div>
            </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let oono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEOBS)
        .find(key => (state.entities.notes.PTOBJECTIVEOBS[key].OOEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEOBS[key].OONTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        oono: oono,
        flagged: state.entities.notes.PTOBJECTIVEOBS[oono].OOGAICYCLEINITIAL ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOGAICYCLESTANCE ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOGAICYCLESWING
            ? true : false
    };
}

const connectedObservationGaitGaitCycle = connect(mapStateToProps)(ObservationGaitGaitCycle);
export { connectedObservationGaitGaitCycle as ObservationGaitGaitCycle };


